<template>
    <modal
        name="signup-modal"
        transition="nice-modal-fade"
        width="370"
        height="380"
        :click-to-close="false"
    >
        <div
            v-if="divideIntoClassLoading"
            class="apply-success-popup"
            data-cy="qr-code-model"
        >
            <div class="popup__head">
                <i class="icon iconfont icon-xuanzhong"></i>恭喜您预约成功
                <i
                    class="icon iconfont icon-guanbi"
                    @click="modalCloseHandler()"
                ></i>
            </div>
            <span class="line"></span>
            <div class="popup__body">
                <div class="apply-wechat-code">
                    <img
                        :src="require('~/assets/img/code_loading.gif')"
                        alt="loading"
                        data-cy="qr-code"
                    >
                </div>
                <div class="apply-wechat-footer">
                    正在为您分班，请稍等...
                </div>
            </div>
        </div>
        <div v-if="!divideIntoClassLoading && !isGtqscz" class="apply-success-popup" data-cy="qr-code-model">
            <div class="popup__head">
                <i class="icon iconfont icon-xuanzhong"></i>{{display.title}}
                <i
                    class="icon iconfont icon-guanbi"
                    @click="modalCloseHandler()"
                ></i>
            </div>
            <span class="line"></span>
            <div class="popup__body">
                <div
                    class="apply-top"
                    @click="handleClick"
                    v-html="codeTopMessage"
                >
                </div>
                <!-- <div class="apply-hint">{{display.top}}</div> -->
                <div class="apply-wechat-code">
                    <img :src="qrcode" alt="code" data-cy="qr-code">
                </div>
                <div class="apply-wechat-footer">
                    {{display.bottom}}
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import Cookies from 'js-cookie';
import productAction from '@base/mixins/productAction';

// 高途-报名成功弹窗-我的课程按钮点击
const STUDY_CLICK = 9542223744886784;
// 高途-0元课报名后引导弹窗曝光
const CODE_SHOW = 9542202978625536;

export default {
    name: 'CourseSignupModal',
    props: {
        qrcode: {
            type: String,
            default: '~assets/img/wechat-code-img.png'
        },
        display: {
            type: Object,
            default: () => ({
                bottom: '长按识别二维码或截图保存后打开微信识别二维码',
                title: '恭喜您预约成功',
                top: '请进入学习中心查看预约的课程',
            })
        },
        divideIntoClassLoading: {
            type: Boolean,
            default: false
        },
        source: {
            type: String,
            default: 'pubQrcode'
        },
        clazzNumber: {
            type: String,
            default: ''
        }
    },
    mixins: [
        productAction
    ],
    computed: {
        codeTopMessage() {
            return this.display.top || '请进入学习中心查看预约的课程';
        }
    },
    watch: {
        divideIntoClassLoading(val, oldVal) {
            try {
                const userinfo = JSON.parse(Cookies.get('__user_info__'));
                const params = {
                    calzz_number: this.clazzNumber,
                    index: userinfo.nationalMobile,
                    source: this.source
                };
                if (val === false && val === !oldVal) {
                    this.$habo.haboViewPage(CODE_SHOW, params);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    },
    methods: {
        modalCloseHandler() {
            this.$emit('on-close');
        },
        handleClick(e) {
            if (e?.target?.nodeName === 'A') {
                this.$habo.haboClickReport(STUDY_CLICK);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.apply-success-popup {
    position: relative;
    padding-bottom: 39px;

    .popup__head {
        position: relative;
        font-size: 20px;
        // font-weight: 500;
        text-align: center;
        color: #32404b;
        line-height: 20px;
        padding: 30px 0;

        .icon-xuanzhong {
            font-size: 24px;
            padding-right: 14px;
            color: #07b906;
            display: inline-block;
            vertical-align: bottom;
        }

        .icon-guanbi {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 18px;
            line-height: 18px;
            color: #bfbfbf;
            display: block;
            cursor: pointer;
        }
    }

    .line {
        display: block;
        width: 310px;
        height: 1px;
        background-color: #ebebeb;
        margin-left: 30px;
    }

    .popup__body {
        position: relative;
        margin: 0 30px;
        text-align: center;

        .apply-top {
            width: 280px;
            height: 20px;
            font-size: 12px;

            // font-weight: 500;
            color: #32404b;
            line-height: 20px;
            margin-top: 10px;
            margin-left: 15px;
        }

        .apply-content {
            position: relative;
            display: table;
            width: 100%;
        }

        .apply-wechat-code {
            display: table-cell;
            width: 150px;
            height: 150px;

            img {
                width: 100%;
                height: auto;
                vertical-align: top;
                margin-left: 80px;
                margin-top: 12px;
            }
        }

        .apply-wechat-footer {
            height: 22px;
            font-size: 14px;

            font-weight: 400;
            color: #414455;
            line-height: 22px;
            margin-top: 10px;
            margin-left: 20px;
        }
    }
}

/deep/ .to-study {
    color: #0890FF;
}
</style>
